import React from "react";
import styled from "styled-components";

interface SFixedInfoBoxContainer {
  sHeight?: number;
  padding?: string;
  hasArrow?: boolean;
}

interface FixedInfoBoxProps extends SFixedInfoBoxContainer {
  label?: string;
  value?: string;
}

export default function FixedInfoBox({
  label,
  value,
  sHeight,
  padding,
  hasArrow,
}: FixedInfoBoxProps) {
  return (
    <FixedInfoBoxContainer
      sHeight={sHeight}
      padding={padding}
      hasArrow={hasArrow}
    >
      <FixedInfoBoxColumn>
        {label && <FixedInfoBoxLabel>{label}</FixedInfoBoxLabel>}
        <FixedInfoBoxValue>{value}</FixedInfoBoxValue>
      </FixedInfoBoxColumn>

      <FixedInfoBoxColumn>
        {hasArrow && (
          <Arrow className="material-icons-outlined">chevron_right</Arrow>
        )}
      </FixedInfoBoxColumn>
    </FixedInfoBoxContainer>
  );
}

const FixedInfoBoxContainer = styled.div<SFixedInfoBoxContainer>`
  cursor: ${({ hasArrow }) => (hasArrow ? "pointer" : "auto")};
  width: 100%;
  height: ${({ sHeight, padding }) => padding ?? sHeight ?? 60}px;
  border-radius: 3px;
  background-color: #f6f6f8;
  padding: ${({ padding }) => padding ?? "11px 16px"};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FixedInfoBoxColumn = styled.div`
  &:first-child {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &:last-child {
    display: flex;
    align-items: center;
  }
`;

const FixedInfoBoxLabel = styled.label`
  font-size: 13px;
  line-height: 19.5px;
  text-align: left;
  color: #9a9fa8;
`;

const FixedInfoBoxValue = styled.div`
  font-size: 14px;
  line-height: 21px;
  font-weight: bold;
  text-align: left;
  color: #858c97;
  overflow-wrap: anywhere;
`;

const Arrow = styled.span`
  font-size: 24px;
  color: #c2cad4;
`;
